export function sanitizeAssessmentHtml(html) {
  if (html === null || html === undefined) return html;

  const stripForcedCasingAndNoWrap = (value) =>
    value
      // Remove style declarations that force uppercase or no-wrap behavior.
      .replace(
        /style\s*=\s*(["'])([\s\S]*?)\1/gi,
        (_match, quote, styleValue) => {
          const cleaned = String(styleValue)
            .replace(/(?:^|;)\s*text-transform\s*:[^;]*/gi, "")
            .replace(/(?:^|;)\s*white-space\s*:[^;]*/gi, "")
            .replace(/(?:^|;)\s*word-break\s*:[^;]*/gi, "")
            .replace(/(?:^|;)\s*overflow-wrap\s*:[^;]*/gi, "")
            .replace(/;{2,}/g, ";")
            .replace(/^\s*;|;\s*$/g, "")
            .trim();

          return cleaned ? `style=${quote}${cleaned}${quote}` : "";
        },
      )
      // Remove bootstrap-like uppercase utility class when present in authored HTML.
      .replace(/class\s*=\s*(["'])([\s\S]*?)\1/gi, (_match, quote, classValue) => {
        const cleaned = String(classValue)
          .split(/\s+/)
          .filter((token) => token && token.toLowerCase() !== "text-uppercase")
          .join(" ")
          .trim();
        return cleaned ? `class=${quote}${cleaned}${quote}` : "";
      })
      // NBSP often prevents wrapping in long passages; normalize to regular spaces.
      .replace(/&nbsp;|\u00a0/gi, " ");

  return stripForcedCasingAndNoWrap(String(html))
    // Normalize common apostrophe entities into a consistent literal form.
    .replace(/&(rsquo|lsquo|apos);/gi, "'")
    .replace(/&#8217;|&#8216;|&#39;|&#x27;|&#x2019;|&#x2018;/gi, "'")
    // Normalize apostrophe-like literals from copy/paste sources.
    .replace(/[\u2019\u2018\u02bc\u02bb`\u00b4]/g, "'")
    // Remove invisible/encoded spaces between apostrophe and following letters.
    .replace(
      /'(?:(?:\s|&nbsp;|&#\d+;|&#x[\da-f]+;|\u00a0|[\u200b-\u200d\ufeff])+|<[^>]+>)+([a-zA-Z])/gi,
      "'$1",
    )
    // Repeat for non-ASCII letters so localized text is also normalized.
    .replace(
      /'(?:(?:\s|&nbsp;|&#\d+;|&#x[\da-f]+;|\u00a0|[\u200b-\u200d\ufeff])+|<[^>]+>)+([^\W\d_])/giu,
      "'$1",
    )
    // Normalize accidental repeated spaces in text nodes.
    .replace(/([^>])\s{2,}(?=[^<])/g, "$1 ");
}
